import { render } from "./InterventoProgramma.vue?vue&type=template&id=0c5bb642&scoped=true"
import script from "./InterventoProgramma.vue?vue&type=script&lang=js"
export * from "./InterventoProgramma.vue?vue&type=script&lang=js"

import "./InterventoProgramma.vue?vue&type=style&index=0&id=0c5bb642&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5bb642"]])

export default __exports__